import { Container, TableContainer, BodyContainer } from "./Table.styles";
import TableEmptyState from "./TableEmptyState";

interface TableProps {
  Header: React.ComponentType;
  rowBuilder: (obj: any) => JSX.Element;
  data: any[];
}

export default ({ Header, rowBuilder, data }: TableProps) => {
  const hasData = data && Object.keys(data).length > 0;

  return (
    <Container>
      <TableContainer>
        {hasData ? (
          <>
            <Header />
            <BodyContainer>
              {data && data.map((obj) => rowBuilder(obj))}
            </BodyContainer>
          </>
        ) : (
          <TableEmptyState />
        )}
      </TableContainer>
    </Container>
  );
};
